import { TAG_UPDATE_TYPE } from "../TagsEditor/consts";

// Pagination constants
export const DEFAULT_PAGINATION_LIMIT = 5;

export const TAGS_VIEWER_HEIGHT = "200px";

// Relationship type constants
export const RELATIONSHIP_TYPE = {
  DIRECT: "direct",
  INDIRECT: "indirect",
};

// Tag update field mapping
export const TAG_UPDATE_CONFIG = {
  [TAG_UPDATE_TYPE.TAG]: {
    idField: "id",
    fieldsToUpdate: ["displayValue", "attributes"],
  },
  [TAG_UPDATE_TYPE.ENTITY_TAG]: {
    idField: "tagId",
    fieldsToUpdate: ["entityTagAttributes"],
  },
};
